/**
 * Enum for logging types.
 * @readonly
 * @enum {string}
 */
export const LOG_TYPE = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
};

/**
 * Process log events
 * @param {String} message - log message
 * @param {LOG_TYPE} type - log type. One of `LOG_TYPE`
 */
function log(message, type = LOG_TYPE.INFO) {
  console[type](message);
}

export default log;
